export default {
  GLOBAL_SOCKET_STATE: 'GLOBAL_SOCKET_STATE',
  IS_OFFLINE: 'IS_OFFLINE',
  GLOBAL_MINIMIZE_APP: 'GLOBAL_MINIMIZE_APP', // isMinimize
  GLOBAL_CALL_STATE: 'GLOBAL_CALL_STATE', // onCall
  GLOBAL_TAB_STATE: 'GLOBAL_TAB_STATE', // selectedTab
  GLOBAL_STATE: 'GLOBAL_STATE', // state
  GLOBAL_STATE_CHANGE: 'GLOBAL_STATE_CHANGE', // team
  GLOBAL_DYNAMIC_UPDATE: 'GLOBAL_DYNAMIC_UPDATE', // global dynamic variable change

  GLOBAL_DYNAMIC_UPDATE_CHAT: 'GLOBAL_DYNAMIC_UPDATE_CHAT', // global dynamic variable change

  CHAT_AGENT_ASSIST: 'CHAT_AGENT_ASSIST', // chat agent assist

  CLEAR_CHAT_AGENT_ASSIST: 'CLEAR_CHAT_AGENT_ASSIST', // clear chat suggestions

  UPDATE_TRANSLATE: 'UPDATE_TRANSLATE', //store translate in redux

  UPDATE_TRANSLATE_CALL: 'UPDATE_TRANSLATE_CALL', //store call translate in redux

  CALL_CHECKLIST: 'CALL_CHECKLIST',
  
  ONLINE_CALL_LIST: 'ONLINE_CALL_LIST', // callList
  ONLINE_TEAM: 'ONLINE_TEAM', // team

  SET_BREAK_LIST: 'SET_BREAK_LIST', // SET_BREAK_LIST
  GET_BREAK_LIST: 'GET_BREAK_LIST', // GET_BREAK_LIST

  PROFILE_TEAM_LIST: 'PROFILE_TEAM_LIST', // teamList
  PROFILE_TEAM: 'PROFILE_TEAM', // team

  CALL_INFO: 'CALL_INFO', // callInfo
  CALL_List: 'CALL_List', // List
  CALL_CUSTOMER_NUMBER: 'CALL_CUSTOMER_NUMBER', // customerNumber
  CALL_CUSTOMER_NAME: 'CALL_CUSTOMER_NAME', // customerName
  CALL_START_TIME: 'CALL_START_TIME', // startTime
  CALL_CURRENT_TIME: 'CALL_CURRENT_TIME', // currentTime
  TRANSCRIPTION_SET: 'TRANSCRIPTION_SET', // transcription add
  TRANSCRIPTION_UPDATE: 'TRANSCRIPTION_UPDATE', // transcription update
  CLEAR_TRANSCRIPTION: 'CLEAR_TRANSCRIPTION', //clear transcription
  AGENT_ASSIST: 'AGENT_ASSIST', // agent assist response
  CLEAR_AGENT_ASSIST: 'CLEAR_AGENT_ASSIST', // clear agent assist response
  CLEAR_CHECKLIST: 'CLEAR_CHECKLIST', // clear checklist

  SUMMARY_SET: 'SUMMARY_SET', // set summary
  SUMMARY_CLEAR: 'SUMMARY_CLEAR', //clear summary
  SUMMARY_LOADING_SET: 'SUMMARY_LOADING_SET', // loading summary

  SET_DISPOSE_SCREEN: "SET_DISPOSE_SCREEN",
  SET_ACTIVE_TAB: "SET_ACTIVE_TAB",
  SET_ACTIVE_TAB_RIGHT: "SET_ACTIVE_TAB_RIGHT",
  SET_LIST_REDUX: "SET_LIST_REDUX",
  SET_CURRENT_LEVEL_TAGS: "SET_CURRENT_LEVEL_TAGS",

  LIVE_AGENT_LIST: "LIVE_AGENT_LIST",
  LIVE_FILTER: "LIVE_FILTER",
  LIVE_STATE_LIST: "LIVE_STATE_LIST",
  LIVE_QUEUE: "LIVE_QUEUE",
  LIVE_SET_AGENT_LIST: "LIVE_SET_AGENT_LIST",
  LIVE_SET_FILTER: "LIVE_SET_FILTER",
  LIVE_SET_STATE_LIST: "LIVE_SET_STATE_LIST",
  LIVE_SET_QUEUE: "LIVE_SET_QUEUE",
  LIVE_DYNAMIC_UPDATE: "LIVE_DYNAMIC_UPDATE",
  UPDATE_LIVE_CHAT_DATA: "UPDATE_LIVE_CHAT_DATA",
  LIVE_TRANSCRIPTION_SET: "LIVE_TRANSCRIPTION_SET",
  LIVE_TRANSCRIPTION_UPDATE: "LIVE_TRANSCRIPTION_UPDATE",
  LIVE_CLEAR_TRANSCRIPTION: "LIVE_CLEAR_TRANSCRIPTION",
  CHAT_SUMMARY: "CHAT_SUMMARY",
  CHAT_SUMMARY_LOADING_SET: "CHAT_SUMMARY_LOADING_SET",
  CHAT_SUMMARY_CLEAR: "CHAT_SUMMARY_CLEAR",

  EMAIL: "EMAIL",
  SMS: "SMS",
  // ACTIVE_TAB: "ACTIVE_TAB",
  UPDATE_MESSAGE: "UPDATE_MESSAGE",

  LOADING_AGENT_ASSIST: "LOADING_AGENT_ASSIST", //Agent Assist loading status
};



// WEBPACK FOOTER //
// src/store/actionTypes/index.js